import type { PublicV2Purchase } from "./public-v2";
import { parseCanonicalAgentId } from "@botnet/shared/runtime-status";

export type AgentStage = { step: 1 | 2 | 3 | 4; label: string; live: false };

/** Public Registry V2 lifecycle only. A readiness attestation is never a hosting observation. */
export function agentStage(purchase: Pick<PublicV2Purchase, "phase">): AgentStage {
  if (purchase.phase === "awaiting_prompt") return { step: 1, label: "receiving prompt", live: false };
  switch (purchase.phase) {
    case "queued": return { step: 2, label: "queued awaiting authorization", live: false };
    case "authorized": return { step: 3, label: "authorized · awaiting readiness", live: false };
    case "ready": return { step: 4, label: "ready · on-chain attestation", live: false };
    case "refunded": return { step: 4, label: "refund credited", live: false };
    case "settled_success": return { step: 4, label: "settlement credited", live: false };
  }
}

export function parseId(raw: string | undefined): bigint | null {
  const canonical = parseCanonicalAgentId(raw);
  return canonical === null ? null : BigInt(canonical);
}
